"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Fila {
    constructor(nombre, tipo, listaAmbito, fila, columna, valor) {
        this.nombre = nombre;
        this.tipo = tipo;
        this.listaAmbito = listaAmbito;
        this.fila = fila;
        this.columna = columna;
        this.valor = valor;
    }
}
exports.Fila = Fila;
